import { render, staticRenderFns } from "./uploadAuth.vue?vue&type=template&id=a87ead20"
import script from "./uploadAuth.vue?vue&type=script&lang=js"
export * from "./uploadAuth.vue?vue&type=script&lang=js"
import style0 from "./uploadAuth.vue?vue&type=style&index=0&id=a87ead20&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports